import React, { Component, Dispatch } from 'react';
import { Log } from 'ng2-logger';
import Translator from '../../../../../core/i18n';
import { Common } from '../../../../../core/common';
import { IChoiceProps, IQuestionChoice } from '../../../../../models/components/add-activity-survey-questions';
import { IAction, IAppState } from '../../../../../models/action/core';
import { connect } from 'react-redux';
import EdiText from 'react-editext';
import Choices from 'react-choices';

const T = Translator.create();
const _logger = Log.create('profile-tabpanel');
let _common: Common;

interface IChoiceState {
    choiceText: string;
    placeHolder: string;
    isEditing: boolean;
    onEditingDisplayOrder: number;
}

export class Choice extends Component<IChoiceProps, IChoiceState> {
    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state = {
            choiceText: '',
            placeHolder: T.t('r_add_answer'),
            isEditing: false,
            onEditingDisplayOrder: -1
        };

        this.props.deleteQuestion.bind(this);
    }

    handleDelete = () => {
        this.props.deleteQuestion(this.props.question.displayOrder, false, T.t('r_delete_survey_question_choice'));
    }

    onChange = (e: any) => {
        if (e && e.target) {
            const question = this.props.question;
            question.description = e.target.value;
            this.props.editQuestion(question);
        }
    }

    onEdit = () => {
        const item = document.getElementById('survey_singlechoice_' + this.props.question.displayOrder);
        if (item) {
            item.focus();
        }
    }

    onAddChoice = () => {
        let endIndex = 0;
        const question = this.props.question;

        if (this.state.choiceText) {
            if (!this.state.isEditing) {
                if (question.questionChoices && question.questionChoices.length > 0) {
                    endIndex = question.questionChoices.sort((a, b) => b.displayOrder - a.displayOrder)[0].displayOrder + 1;
                }
                const item: IQuestionChoice = { surveyQuestionChoiceId: '0', text: this.state.choiceText, displayOrder: endIndex };
                question.questionChoices ? question.questionChoices.push(item) : question.questionChoices = [item];
                this.props.editQuestion(question);
                this.setState({ choiceText: '' });
            } else if (this.state.onEditingDisplayOrder !== -1) {
                if (question) {
                    if (question.questionChoices) {
                        question.questionChoices.filter(q => q.displayOrder === this.state.onEditingDisplayOrder).forEach(q => q.text = this.state.choiceText);
                        this.props.editQuestion(question);
                        this.setState({
                            choiceText: '',
                            isEditing: false,
                            onEditingDisplayOrder: -1
                        });
                    }
                }
            }
        }
    }

    onDeleteChoice = (displayOrder: number) => {
        const question = this.props.question;

        if (question.questionChoices) {
            const choices = question.questionChoices.sort((a, b) => a.displayOrder - b.displayOrder);
            if (choices.length) {
                const sourceItem = choices.find(c => c.displayOrder === displayOrder);

                if (sourceItem) {
                    choices.splice(sourceItem.displayOrder, 1);
                    choices.filter(q => q.displayOrder >= displayOrder).forEach(q => q.displayOrder = q.displayOrder - 1);
                    question.questionChoices = choices;
                    this.props.editQuestion(question);
                }
            }
        }
    }

    handleChangeChoiceText = (e: any) => {
        if (e && e.target) {
            this.setState({ choiceText: e.target.value });
        }
    }

    onKeyUp = (e: any) => {
        if (e && (e.keyCode === 13 || e.charCode === 13)) {
            this.onAddChoice();
        }

        if (e && (e.keyCode === 27 || e.charCode === 27)) {
            this.cancelEditing();
        }
    }

    handleSave = (text: string, displayOrder: number) => {
        if (this.props.question) {
            const question = this.props.question;

            if (question.questionChoices) {
                question.questionChoices.filter(q => q.displayOrder === displayOrder).forEach(q => q.text = text);
                this.props.editQuestion(question);
            }
        }
    }

    onEditing = (displayOrder: number) => {
        if (this.props.question) {
            const question = this.props.question;

            if (question.questionChoices) {
                const item = question.questionChoices.find(q => q.displayOrder === displayOrder);
                if (item) {
                    this.setState({ choiceText: item.text, isEditing: true, onEditingDisplayOrder: displayOrder });
                }
            }

            const input = document.getElementById('editing-input');
            if (input) {
                input.focus();
            }
        }
    }

    cancelEditing = () => {
        this.setState({ choiceText: '', isEditing: false, onEditingDisplayOrder: -1 });
    }

    public render() {
        return (
            <React.Fragment>
                <div className="w-85">
                    <div className="form-input form-group">
                        <div className="form-input form-group survey_input_padding">
                            <input type="text" required={true} onChange={this.onChange}
                                value={this.props.question.description} />
                            <span className="highlight" />
                            <span className="bar" />
                            <label style={{right: document.body.getAttribute('dir') == 'rtl'? '10px': '0px'}}>{T.t('r_activity_survey_question_name_placeholder')}</label>
                        </div>
                    </div>
                    <div className="row" style={{ marginTop: '1em' }}>
                        {this.props.question.questionChoices && this.props.question.questionChoices.length ? (
                            this.props.question.questionChoices.sort((a, b) => a.displayOrder - b.displayOrder).map((choice, index) => (
                                <div key={index} className="col-12">
                                    {/* <div className="control-group survey_choose">
                                        <div className="tick-radio position-relative">
                                            <div className="ml-0 control_group survey_choose">
                                                <label className="pl-4 control control--radio">
                                                    <input type="radio" name="radio" checked={true} />
                                                    <div className="control__indicator" />
                                                </label>
                                            </div>
                                        </div>
                                        <EdiText
                                            type="text"
                                            // tslint:disable-next-line: jsx-no-lambda
                                            onSave={(value: any) => this.handleSave(value, index)}
                                            value={choice.text}
                                            showButtonsOnHover={true}
                                            saveButtonClassName="hideEditextSaveButton"
                                            cancelButtonClassName="hideEditextCancelButton"
                                            editButtonClassName="hideEditextEditButton"
                                            validationMessage={T.t('r_editext_character_error', { 0: 1 })}
                                            // tslint:disable-next-line:jsx-no-lambda
                                            validation={val => val.trim().length >= 1}
                                            editOnViewClick={true}
                                            submitOnEnter={true}
                                            cancelOnEscape={true}
                                            className={'text-oversize'}
                                            cancelOnUnfocus={true}
                                        />
                                        <a className="radio_delete_btn" onClick={this.onDeleteChoice.bind(this, choice.displayOrder)}>
                                            <i className="material-icons" >close</i>
                                        </a>
                                    </div> */}
                                    <div className="control-group survey_choose" style={{ display: 'initial' }}>
                                        <div className="form-input form-group">
                                            <div className="form-input form-group survey_input_padding">
                                                <input type="text" required={true} onChange={this.onChange}
                                                    value={choice.text} />
                                                <span className="highlight" />
                                                <span className="bar" />
                                                <label style={{right: document.body.getAttribute('dir') == 'rtl'? '10px': '0px'}}>{T.t('r_choice')}</label>
                                            </div>
                                        </div>
                                        <a className="radio_delete_btn"
                                            style={{ marginTop: '-40px' }}
                                            onClick={this.onDeleteChoice.bind(this, choice.displayOrder)}>
                                            <i className="material-icons" >close</i>
                                        </a>
                                    </div>
                                </div>
                            ))
                        ) : ''}
                        <div className="col-12">

                            <input
                                id="editing-input"
                                onKeyUp={this.onKeyUp}
                                value={this.state.choiceText}
                                placeholder={this.state.placeHolder}
                                onChange={this.handleChangeChoiceText}
                                className="survey_input" type="text"
                                style={{ marginTop: 10, height: 56, float: 'left' }}
                            />
                            <a className="add_asnwer_btn" onClick={this.onAddChoice}>
                                <i className="material-icons" style={{ color: 'white' }}>{this.state.isEditing ? 'upgrade' : 'add'}</i>
                            </a>
                            {
                                this.state.isEditing ? (
                                    <a className="add_asnwer_btn" onClick={this.cancelEditing}>
                                        <i className="material-icons" style={{ color: 'white' }}>close</i>
                                    </a>
                                ) : ''
                            }

                        </div>
                    </div>
                </div>
                <div>
                    <div className="btn_container">
                        <span className="move_btn" {...this.props.dragHandleProps}>
                            <i className="material-icons">open_with</i>
                        </span>
                        <span className="delete_btn" onClick={this.handleDelete}>
                            <i className="material-icons">close</i>
                        </span>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IChoiceProps): IChoiceProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: IChoiceProps = Object.assign({}, ownProps, {
        coursePageActivityId: state.coursePage.coursePageActivityId,
        coursePageClassId: state.coursePage.coursePageClassId
    });

    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CChoice = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(Choice);

export default CChoice;
